import React from "react";
import { Plus, X, BedDouble } from "lucide-react";
import { ROOM_TYPES, ROOM_PAX_DEFAULT, newRoomConfig } from "@/pages/cotizador/shared";

// Configuración de habitaciones por defecto, aplicada al añadir un alojamiento.
export function CotRoomConfig({ config, numTravelers, onChange }) {
  const list = config || [];
  const totalRooms = list.reduce((s, r) => s + (r.quantity || 1), 0);
  const totalPax = list.reduce((s, r) => s + (r.pax || 0) * (r.quantity || 1), 0);
  const mismatch = numTravelers && totalPax !== numTravelers;

  const update = (i, patch) => {
    const next = [...list];
    next[i] = { ...next[i], ...patch };
    if ("room_type" in patch && !("pax" in patch)) next[i].pax = ROOM_PAX_DEFAULT[patch.room_type] || next[i].pax;
    onChange(next);
  };
  const remove = (i) => onChange(list.filter((_, ii) => ii !== i));
  const add = () => onChange([...list, newRoomConfig()]);

  return (
    <div className="rounded-md border bg-muted/30 px-3 py-2.5" data-testid="cot-room-config">
      <div className="mb-2 flex flex-wrap items-center gap-2">
        <span className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground"><BedDouble className="h-3.5 w-3.5" /> Habitaciones por defecto</span>
        <span className="text-[11px] text-muted-foreground">Se aplican al añadir un alojamiento</span>
        <span className="ml-auto text-[11px]">
          Total: <span className="font-semibold tabular-nums">{totalRooms} habs</span> · <span className={`tabular-nums ${mismatch ? "font-semibold text-amber-600" : ""}`}>{totalPax} pax</span>
          {mismatch ? <span className="ml-1 text-amber-600">≠ viaje de {numTravelers}</span> : null}
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {list.map((r, i) => (
          <div key={r.id || i} className="inline-flex items-center gap-1 rounded border bg-background px-2 py-1 text-xs" data-testid={`cot-rc-${i}`}>
            <input type="number" min="1" max="20" value={r.quantity || 1} onChange={(e) => update(i, { quantity: parseInt(e.target.value || "1", 10) })} className="w-9 bg-transparent text-center outline-none" title="Cantidad" />
            <span className="text-muted-foreground">×</span>
            <select value={r.room_type} onChange={(e) => update(i, { room_type: e.target.value })} className="bg-transparent outline-none">
              {ROOM_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
            <span className="text-muted-foreground">·</span>
            <input type="number" min="1" max="20" value={r.pax || 1} onChange={(e) => update(i, { pax: parseInt(e.target.value || "1", 10) })} className="w-9 bg-transparent text-center outline-none" title="Pax por habitación" />
            <span className="text-muted-foreground">pax</span>
            <button onClick={() => remove(i)} className="ml-1 text-muted-foreground hover:text-destructive" title="Quitar"><X className="h-3 w-3" /></button>
          </div>
        ))}
        <button onClick={add} className="inline-flex items-center gap-1 rounded border border-dashed px-2 py-1 text-[11px] text-muted-foreground hover:border-primary hover:text-primary" data-testid="cot-rc-add">
          <Plus className="h-3 w-3" /> Tipo de habitación
        </button>
      </div>
    </div>
  );
}
